import PropTypes from 'prop-types'
import React from 'react'
import PostIdentColoredHeading from "../PostIdentColoredHeading";

export default function MethodTitle({heading, subHeading, info, testId}) {
    return <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4">
        <div className="row pb-3">
            <PostIdentColoredHeading methodName={heading} testId={testId}/>
        </div>
        {subHeading &&
            <p className="mb-1" style={{fontSize: '18px'}} data-test-id={testId + '-sub'}>
                {<div dangerouslySetInnerHTML={{__html: subHeading}}/>}
            </p>
        }
        {<p dangerouslySetInnerHTML={{__html: info}} />}
    </div>
}

MethodTitle.propTypes = {
    heading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    subHeading: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    info: PropTypes.string,
    testId: PropTypes.string.isRequired
}